import { useContext, useCallback, useEffect, useRef } from "react";
import { GlobalContext } from "./GlobalContext";

//Reusable "discard unsaved changes?" confirmation, so the same guard can be
//dropped in wherever leaving a view would throw away edits.
//
//Returns an async function; call it with whether there are unsaved changes.
//It resolves true when it's safe to proceed (nothing unsaved, or the user
//chose to discard) and false when the user wants to stay and keep editing.
//
//  const confirmLeave = useDiscardGuard();
//  const handleClose = async () => { if (await confirmLeave(isDirty)) onClose(); };
export default function useDiscardGuard() {
  const { getMsgBoxResult } = useContext(GlobalContext);
  return useCallback(async (isDirty, opts = {}) => {
    if (!isDirty) return true;
    const choice = await getMsgBoxResult({
      on: true,
      title: opts.title || "Discard changes?",
      message: opts.message ||
        "You have unsaved changes. Are you sure you want to discard them and leave?",
      buttons: ["Discard changes", "Keep editing"],
    });
    return choice === "Discard changes";
  }, [getMsgBoxResult]);
}

//Register the current view's unsaved-changes state with the global nav-guard
//registry, so app-level navigation (top tabs, etc.) can warn before it unmounts
//this view. Pass the live dirty flag; it's read fresh whenever nav checks.
export function useLeaveGuard(isDirty) {
  const { registerNavGuard } = useContext(GlobalContext);
  const dirtyRef = useRef(isDirty);
  dirtyRef.current = isDirty;
  useEffect(() => registerNavGuard(() => dirtyRef.current), [registerNavGuard]);
}

//Shallow set equality helper for computing dirtiness of permission/field sets.
export function setsEqual(a, b) {
  if (a === b) return true;
  if (!a || !b || a.size !== b.size) return false;
  for (const v of a) if (!b.has(v)) return false;
  return true;
}
